import React, { useEffect, useState } from "react";
import { Card, Col, Form, Input, Row, Upload } from "antd";
import { InboxOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dispatch, useSelector } from "../../../../redux/store";
import {
  getByOtherTypeId,
  updateOtherType,
} from "../../../../redux/action/otherType";
import { openNotification } from "../../../../global/item/Notification/Notification";
import Loading from "../../../../global/item/Loading/loading";
import ButtonBottom from "../../../../global/item/ButtonComponent/ButtonBottom";
import {  Product_Banner } from "../../../../utils/formatType";

const { Dragger } = Upload;

function BannerProductEditScreen() {
  const { t } = useTranslation();
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [form] = Form.useForm();
  const { otherTypeDetail } = useSelector((state) => state.otherType);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const id = useParams().id;

  useEffect(() => {
    dispatch(getByOtherTypeId(id));
  }, [id]);

  // useEffect(() => {
  //   if (globalDetail.image) {
  //     setUploadedImage(globalDetail.image);
  //   }
  // }, [globalDetail.image]);

  const handleFileChange = (info: any) => {
    const file = info.file.originFileObj;
    if (file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target && e.target.result) {
          const uploadedImage = e.target.result.toString();
          setUploadedImage(uploadedImage);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCloseImg = () => {
    setUploadedImage(null);
  };
const handleSubmit = async () => {
  setLoading(true);
  try {
    const values = await form.validateFields();

    // Nếu uploadedImage khác otherTypeDetail.images[0] → mới upload
    let uploadedImgUrl: string | undefined = undefined;

    if (uploadedImage && uploadedImage !== otherTypeDetail?.images?.[0]) {
      try {
        const file = await fetch(uploadedImage).then((res) => res.blob());
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "hoatuoi");

        const res = await fetch(
          "https://api.cloudinary.com/v1_1/dcxwarx50/image/upload",
          { method: "POST", body: formData }
        );

        const data = await res.json();
        uploadedImgUrl = data.secure_url;
      } catch (err) {
        console.error("Upload failed:", err);
        openNotification({
          type: "error",
          message: "Lỗi upload ảnh",
          description: "Ảnh không được tải lên Cloudinary!",
        });
        setLoading(false);
        return; // dừng submit nếu upload thất bại
      }
    }

    // Nếu không có ảnh mới → giữ ảnh cũ
    const imagesToSend =
      uploadedImgUrl
        ? [uploadedImgUrl]
        : otherTypeDetail?.images
        ? otherTypeDetail.images
        : undefined;

    // Dispatch dữ liệu
    await dispatch(
      updateOtherType({
        id: Number(id),
        a: {
          title: values.title,
          description: values.description,
          type: Product_Banner,
          images: imagesToSend,
        },
      })
      
    );

    openNotification({
      type: "success",
      message: t("update"),
      description: t("messUpdate"),
    });
        navigate("/product/banner")

  } catch (err) {
    console.error(err);
    openNotification({
      type: "error",
      message: "Lỗi",
      description: "Dữ liệu cập nhật thất bại!",
    });
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    if (otherTypeDetail) {
      form.setFieldsValue({
        title: otherTypeDetail.title,
        description: otherTypeDetail.description,
        // Nếu có image hoặc field khác
      });
      if (otherTypeDetail.images) {
        setUploadedImage(otherTypeDetail.images[0]);
      }
    }
  }, [otherTypeDetail, form]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <Form
          form={form}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          autoComplete="off"
          requiredMark={false}
          initialValues={{
            title: otherTypeDetail.title,
            description: otherTypeDetail.description,
          }}
        >
          <Card className="layoutItem">
            <h3 style={{ color: `var(--primary-color)`, marginBottom: 8 }}>
              {t("basicInformation")}
            </h3>
            <Row gutter={[20, 0]}>
              <Col xl={12}>
                <Form.Item
                  label={"Tiêu đề"}
                  name="title"
                  initialValue={otherTypeDetail?.title}
                  rules={[{ required: true, message: t("titleInfo.message") }]}
                >
                  <Input placeholder={t("titleInfo.placeholder")} />
                </Form.Item>
              </Col>
              <Col xl={12}>
                <Form.Item
                  label={"Mô tả"}
                  name="description"
                  initialValue={otherTypeDetail?.description}
                  rules={[{ required: true, message: t("titleInfo.message") }]}
                >
                  <Input placeholder={t("titleInfo.placeholder")} />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card className="layoutItem">
            <h3 style={{ color: `var(--primary-color)` }}>{t("imageInfo")}</h3>
            <Row gutter={[20, 0]} style={{ margin: "16px 0" }}>
              <Col xl={24}>
                {uploadedImage ? (
                  <Col xl={24}>
                    <div>
                      <CloseOutlined
                        style={{
                          position: "absolute",
                          right: 24,
                          top: 12,
                          zIndex: 999,
                          fontSize: 16,
                        }}
                        className="iconCustom"
                        onClick={handleCloseImg}
                      />
                      <img
                        src={uploadedImage}
                        alt="Uploaded"
                        style={{
                          border: `var(--border-line)`,
                          borderRadius: 10,
                          width: "100%",
                          height: 400,
                          objectFit: "contain",
                          padding: 10,
                          background: "rgba(0, 0, 0, 0.02)",
                          position: "relative",
                        }}
                      />
                    </div>
                  </Col>
                ) : (
                  <Form.Item
                    name="image"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn ảnh!",
                      },
                    ]}
                  >
                    <Dragger
                      name="file"
                      multiple={false}
                      showUploadList={false}
                      onChange={handleFileChange}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">{t("titleFile")}</p>
                      <p className="ant-upload-hint">{t("descFile")}</p>
                    </Dragger>
                  </Form.Item>
                )}
              </Col>
            </Row>
            <p style={{ margin: 0 }}>{t("sizeIdeal")}: 1920 x 875</p>
          </Card>
          <ButtonBottom
            onContinueClick={handleSubmit}
            btnCancel={t("cancel")}
            btnContinue={t("continue")}
          />
        </Form>
      )}
    </div>
  );
}

export default BannerProductEditScreen;
